/**
 * 
 * Column Defination
 * {
 *   ...Datagrid Column
 *   printWidth: number
 *   printType: "number" | "string" //default string
 *   printAlign: "left" | "center" | "right" //default left
 *   printWrapMode: "none" | "wrap" | "cut" //default cut
 * }
 */

import { blue, yellow } from "@mui/material/colors"
import { numberFormat } from "utils"
// import { subStringTH } from "./substringTH"
import dayjs from "dayjs"



export const printTableWrapTextMultiPage = ({ doc, dataTable, columns, startX, startY, fontSize = 14
  , lineHeight = 0.21, defaultWrapMode = 'cut', isPrintLine = false, isPrintLineColumn = false
  , maxYPos, printTopSection }) => {

  doc.setFontSize(fontSize)
  const dataBoxW = columns.reduce((acc, col) => acc + (col.printWidth || 0.5), 0)
  const padTop = isPrintLine ? 0.1 : 0

  const printColHeader = (y) => {
    let xPos = startX
    y += lineHeight - 0.1
    doc.setFillColor(blue[100])
    doc.rect(xPos, y, dataBoxW, lineHeight + 0.1, "F")
    doc.line(xPos, y, xPos + dataBoxW, y)
    y += lineHeight
    if (isPrintLineColumn) doc.line(xPos, y - lineHeight, xPos, y + lineHeight)
    for (const col of columns) {
      doc.text(col.headerName, xPos + (col.printWidth || 0.5) / 2, y, { align: "center" })
      xPos += col.printWidth || 0.5
      if (isPrintLineColumn) doc.line(xPos, y - lineHeight, xPos, y + lineHeight)
    }
    y += 0.1
    doc.line(startX, y, startX + dataBoxW, y)
    y += 0.1
    return y
  }

  let yPos = printColHeader(startY)
  let isFirstRow = true
  let isPageFirstRow = true
  for (const row of dataTable) {
    if (yPos > maxYPos) {
      doc.addPage()
      yPos = printTopSection ? printTopSection(doc) : startY
      yPos = printColHeader(yPos)
      yPos += 0.1
      isPageFirstRow = true
    }

    let xPos = startX
    yPos += padTop
    if (isFirstRow) {
      isFirstRow = false
      if(!isPrintLine){
        yPos += 0.1
      }
    }
    // row.printLineTop: separator above this row only (e.g. first row of a group) when isPrintLine is off;
    // skipped right under the column header, which already has its own line
    if (row.printLineTop && !isPrintLine && !isPageFirstRow) {
      const lineY = yPos - lineHeight * 0.75
      doc.line(startX, lineY, startX + dataBoxW, lineY)
    }
    isPageFirstRow = false
    const isSpecialRow = row.id === 0
    if (isSpecialRow) {
      doc.setFont("THSarabun", "bold")
      doc.setFillColor(yellow[100])
      doc.rect(startX, yPos - (isPrintLine ? lineHeight : 0.1), dataBoxW, lineHeight + 0.1, "F")
        doc.line(startX, yPos - (isPrintLine ? lineHeight : 0.1), startX + dataBoxW, yPos - (isPrintLine ? lineHeight : 0.1))
      if (!isPrintLine) {
        yPos += 0.1
      } 
    }
    let textNumRow = 1
    let isFirstCol = true
    for (const col of columns) {
      if (isFirstCol) {
        isFirstCol = false
        if (isPrintLineColumn) {
          doc.line(xPos, yPos - padTop * 2, xPos, yPos + lineHeight * textNumRow - padTop)
        }
      }
      col.printWrapMode = col.printWrapMode || defaultWrapMode
      let printStr = ""
      if (col.printType === "number") {
        printStr = row[col.field] != null ? numberFormat(row[col.field]) : col.printNullChar ?? '-'
      } else if (col.printType === "datetime") {
        printStr = row[col.field] != null ? dayjs(row[col.field]).format(col.printFormat ?? "DD/MM HH:mm") : col.printNullChar ?? '-'
      } else {
        printStr = row[col.field] != null ? `${row[col.field]}` : col.printNullChar ?? '-'
      }
      const addX = col.printAlign === "center" ?
        (col.printWidth || 0.5) / 2 : col.printAlign === "right" ?
          (col.printWidth || 0.5) - 0.05 : 0.05
      if (col.printWrapMode === "none") {
        doc.text(printStr, xPos + addX, yPos, { align: col.printAlign || "left" })
      } else if (col.printWrapMode === "wrap" || col.printWrapMode === "cut") {
        const printStrs = doc.splitTextToSize(printStr, (col.printWidth || 0.5) - 0.1)
        if (col.printWrapMode === "wrap") {
          let index = 0
          for (const line of printStrs) {
            doc.text(line, xPos + addX, yPos + index * lineHeight, { align: col.printAlign || "left" })
            index++
          }
          if (printStrs.length > textNumRow) textNumRow = printStrs.length
        } else {
          doc.text(printStrs[0], xPos + addX, yPos, { align: col.printAlign || "left" })
        }
      }
      xPos += col.printWidth || 0.5
      if (isPrintLineColumn) doc.line(xPos, yPos - padTop * 2, xPos, yPos + lineHeight * textNumRow - padTop)
    }
    yPos += lineHeight * textNumRow
    if (isPrintLine) doc.line(startX, yPos - padTop, startX + dataBoxW, yPos - padTop)
    if (isSpecialRow) {
      doc.line(startX, yPos - 0.1, startX + dataBoxW, yPos - 0.1)
      doc.setFont("THSarabun", "normal")
    }
  }
  return yPos
}

export const printTableWrapText = ({ doc, dataTable, columns, startX, startY, fontSize = 14
  , lineHeight = 0.21, defaultWrapMode = 'cut', isPrintLine = false, isPrintLineColumn = false }) => {
  let xPos = startX
  let yPos = startY
  doc.setFontSize(fontSize)

  const dataBoxW = columns.reduce((acc, col) => acc + (col.printWidth || 0.5), 0)

  xPos = startX
  yPos += lineHeight - 0.1
  doc.setFillColor(blue[100])
  doc.rect(xPos, yPos, dataBoxW, lineHeight + 0.1, "F")
  doc.line(xPos, yPos, xPos + dataBoxW, yPos)

  yPos += lineHeight


  //yPos -= 0.1
  if (isPrintLineColumn) {
    doc.line(xPos, yPos - lineHeight, xPos, yPos + lineHeight)
  }
  for (const col of columns) {

    doc.text(col.headerName, xPos + (col.printWidth || 0.5) / 2, yPos, { align: "center" })
    xPos += col.printWidth || 0.5
    if (isPrintLineColumn) {
      doc.line(xPos, yPos - lineHeight, xPos, yPos + lineHeight)
    }
  }

  yPos += 0.1
  doc.line(startX, yPos, startX + dataBoxW, yPos)
  yPos += lineHeight
  if (isPrintLine) {
    yPos -= 0.1
  }
  for (const row of dataTable) {
    xPos = startX

    if (row.id === 0) {
      doc.setFont("THSarabun", "bold")
      doc.setFillColor(yellow[100])
      doc.rect(startX, yPos - 0.1, dataBoxW, lineHeight + 0.1, "F")
      doc.line(startX, yPos - 0.1, startX + dataBoxW, yPos - 0.1)
      yPos += 0.1
    }
    let textNumRow = 1
    let isFirstCol = true
    for (const col of columns) {
      if (isFirstCol) {
        isFirstCol = false
        if (isPrintLineColumn) {
          doc.line(xPos, yPos + 0.1 - lineHeight, xPos, yPos + 0.1 + lineHeight * (textNumRow - 1))
        }
      }
      col.printWrapMode = col.printWrapMode || defaultWrapMode
      // console.log("col.printWrapMode::", col.printWrapMode)
      let printStr = ""
      if (col.printType === "number") {
        printStr = row[col.field] != null ? numberFormat(row[col.field]) : col.printNullChar ?? '-'
      } else if (col.printType === "datetime") {
        printStr = row[col.field] != null ? dayjs(row[col.field]).format(col.printFormat ?? "DD/MM HH:mm") : col.printNullChar ?? '-'
      } else {
        const str = row[col.field] != null ? `${row[col.field]}` : col.printNullChar ?? '-'
        // printStr = subStringTH(str, col.printMaxLength || Math.floor((13 * col.printWidth || 0.5)))

        printStr = str
      }
      const addX = col.printAlign === "center" ?
        (col.printWidth || 0.5) / 2 : col.printAlign === "right" ?
          (col.printWidth || 0.5) - 0.05 : 0.05
      if (col.printWrapMode === "none") {
        doc.text(printStr, xPos + addX, yPos, { align: col.printAlign || "left" })
      } else if (col.printWrapMode === "wrap" || col.printWrapMode === "cut") {
        const printStrs = doc.splitTextToSize(printStr, (col.printWidth || 0.5) - 0.1)
        if (col.printWrapMode === "wrap") {
          let index = 0
          for (const line of printStrs) {
            doc.text(line, xPos + addX, yPos + index * lineHeight, { align: col.printAlign || "left" })
            index++
          }
          if (printStrs.length > textNumRow) {
            textNumRow = printStrs.length
          }
        } else { //default cut text
          doc.text(printStrs[0], xPos + addX, yPos, { align: col.printAlign || "left" })
        }

      } else {

      }
      xPos += col.printWidth || 0.5
      if (isPrintLineColumn) {
        doc.line(xPos, yPos + 0.1 - lineHeight, xPos, yPos + 0.1 + lineHeight * (textNumRow - 1))
      }
    }
    if (isPrintLine) {
      doc.line(startX, yPos + 0.1, startX + dataBoxW, yPos + 0.1)
    }
    yPos += lineHeight * textNumRow
    if (row.id === 0) {
      yPos -= 0.1
      doc.line(startX, yPos, startX + dataBoxW, yPos)
      doc.setFont("THSarabun", "normal")
    }
  }
  return yPos
}